import { create } from "zustand";

export interface JdMessageMeta {
  source: "paste" | "web_import" | "job";
  title?: string;
}

interface JdMessageMetaState {
  /** Map of message-id → JD metadata for messages sent via the "Search by JD" feature. */
  meta: Record<string, JdMessageMeta>;
  /** A pre-registration slot: the NEXT user message created should inherit this metadata. */
  pending: JdMessageMeta | null;
  /** Queue metadata so the next `useAssistant.send()` call picks it up. */
  setPending: (meta: JdMessageMeta) => void;
  /** Called by the message-creation path to consume the pending slot and bind it to a message id. */
  consumeForMessage: (messageId: string) => void;
  /** Direct set (used when the message id is known upfront, e.g. hero flow). */
  markMessage: (messageId: string, meta: JdMessageMeta) => void;
  /** Lookup. */
  getForMessage: (messageId: string) => JdMessageMeta | null;
}

export const useJdMessageMeta = create<JdMessageMetaState>((set, get) => ({
  meta: {},
  pending: null,
  setPending: (pending) => set({ pending }),
  consumeForMessage: (messageId) => {
    const { pending } = get();
    if (!pending) return;
    set((s) => ({
      pending: null,
      meta: { ...s.meta, [messageId]: pending },
    }));
  },
  markMessage: (messageId, meta) =>
    set((s) => ({ meta: { ...s.meta, [messageId]: meta } })),
  getForMessage: (messageId) => get().meta[messageId] ?? null,
}));
